import React, {FunctionComponent, MouseEvent} from 'react';
import './Minibutton.less';

interface MinibuttonProps {
	text: string | number,
	onClick?: (e: MouseEvent) => void,
	isTransparent?: boolean,
	isBig?: boolean,
	isPressed?: boolean
}

export const Minibutton: FunctionComponent<MinibuttonProps> = ({text, onClick, isTransparent, isBig, isPressed}) => {
	return (
		<button
			className={`minibutton ${isTransparent ? 'minibutton--transparent' : ''} ${
				isPressed ? 'minibutton--pressed' : ''
			} ${
				onClick ? 'minibutton--clickable' : ''
			} ${
				isBig ? 'minibutton--big' : ''
			}`}
			onClick={onClick}
		>
			{text}
		</button>
	);
};
